import { render, staticRenderFns } from "./GalleryColumn.vue?vue&type=template&id=b7650a8a&scoped=true"
import script from "./GalleryColumn.vue?vue&type=script&lang=ts"
export * from "./GalleryColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7650a8a",
  null
  
)

export default component.exports